import React, { useEffect } from 'react';

const Header = (props) => {
    return (<h1>{props.text}</h1>);
}

export default Header;